
import {Component, Mixins} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {KiymetTakdirininYapilmasiTalep} from "@/interface/IUyapTalep";
import Dates from "@/components/inputs/Dates.vue";
import AvukatTalepMalTuruRadio from "@/components/radio/uyap/AvukatTalepMalTuruRadio.vue";

@Component({
  components: {AvukatTalepMalTuruRadio, Dates}
})
export default class KiymetTakdirininYapilmasiTalepEvrakForm extends Mixins(ObjectInputMixin) {
  localValue!: KiymetTakdirininYapilmasiTalep;
}
